import { UserSessionInfo } from '../types';
import { Sender } from 'xstate';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';

import models from '../../../model';

export type SessionWatcherCallback = Sender<
  | {
      type: 'SESSION_STATE_LOGGED_IN' | 'SESSION_STATE_LOGGED_OUT';
      data: UserSessionInfo;
    }
  | { type: 'GAMING_USER_DETAILS_FETCHED' }
>;

export const watchSession = () =>
  asyncCallback(async (callback: SessionWatcherCallback) => {
    const watcherOptions = {
      callback,
    };

    return models.sessionWatcher(watcherOptions);
  });
